<template>
    <div class="w-100 destination-auto-complete">
        <div class="">
            <vue-select
                @input="updateValue"
                class="border-0 ml-2 w-100"
                :placeholder="placeholder"
                :disabled="inputDisabled"
                :options="$store.state.planner.destinations"
                label="name"
            >
                <template #option="{ name, address }">
                    <h4 style="margin: 0">{{ name }}</h4>
                    <em>{{ address }}</em>
                </template>
                <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                        No results found for <em>{{ search }}</em>.
                    </template>
                </template>
            </vue-select>
        </div>
    </div>
</template>
<script>

import { mapActions, mapMutations } from 'vuex'

export default {
    name: 'destination-auto-complete',
    props: {
        value: {
            type: String,
        },
        placeholder: {
            type: String,
            default: 'Enter value',
        },
        inputDisabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {}
    },
    methods: {
        ...mapActions([
            'retrievePlannerDestinations',
        ]),
        ...mapMutations([
            'setCurrentDestination',
        ]),
        updateValue(value) {
            if (value) {
                this.setCurrentDestination(value)
                this.$emit('input', value.full_name)
            }
        },
    },
    mounted() {
        this.retrievePlannerDestinations()
    },
}
</script>

<style>
    .destination-auto-complete .vs__dropdown-toggle {
        border:  none !important;
    }
</style>
